<div class="confirm">
  <h1 mat-dialog-title> {{title}} </h1>
  
  <div mat-dialog-content> {{message}}</div>
  
  <div mat-dialog-actions class="action">
    
    <button mat-stroked-button color="basic" *ngIf="showFinish==false" (click)="onDismiss()">Cancel</button>

    <button mat-flat-button color="primary" *ngIf="showFinish==true" (click)="onDismiss()">Continue Editing</button>

    <div class="signature">
      <button mat-stroked-button class="finish" *ngIf="showFinish==true" (click)="onFinish()">Finish</button>&nbsp;
      <button mat-raised-button color="warn" *ngIf="showFinish==false" (click)="onConfirm()">{{confirm}}</button>   
    </div>
  </div>

</div>



